import React from 'react';

const Footer = ({ onBack, onContinue, continueText = 'Continue', backText = 'Back', continueDisabled = false, showBack = true, showContinue = true, isLoading = false }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-gray-200 shadow-lg z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between gap-4">
          {/* Back Button */}
          {showBack ? (
            <button
              onClick={onBack}
              className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-gray-200 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 shadow-sm hover:shadow-md"
            >
              <i className="fa-solid fa-arrow-left text-sm"></i>
              {backText}
            </button>
          ) : (
            <div></div>
          )}

          {/* Continue Button */}
          {showContinue && (
            <button
              onClick={onContinue}
              disabled={continueDisabled || isLoading}
              className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-indigo-600 via-purple-600 to-amber-500 text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-md"
            >
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  Processing...
                </>
              ) : (
                <>
                  {continueText}
                  <i className="fa-solid fa-arrow-right text-sm"></i>
                </>
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Footer;
